module.exports = __webpack_public_path__ + "static/media/Allfileicon.d419477c.svg";